import React from 'react';
import { Link } from 'react-router-dom';

const AdminNav = () => {
  return (
    <div style={{ marginBottom: '20px', backgroundColor: '#f2f2f2', padding: '10px' }}>
      <Link to="/admin/dashboard" style={{ marginRight: '20px' }}>Dashboard</Link>
      <Link to="/admin/users" style={{ marginRight: '20px' }}>Users</Link>
      <Link to="/admin/quiz-results" style={{ marginRight: '20px' }}>Quiz Results</Link>
      <Link to="/admin/reports">Reports</Link>
    </div>
  );
};

export default AdminNav;
